import React from 'react';

import PropTypes from 'prop-types';

import { Text } from 'apps/auth/components/common/Text/Text';

import { TableRowContainer, TableRowContent, TableRowTitle } from './styles';

export const TableRow = ({ textColor = 'primary', titleColor = 'secondary', ...props }) => {
    return (
        <TableRowContainer pseudoTable={props.pseudoTable} onClick={props.onClick}>
            <TableRowTitle pseudoTable={props.pseudoTable}>
                <Text color={titleColor} size={props.pseudoTable ? 'secondary' : 'main'}>
                    {props.title}
                </Text>
            </TableRowTitle>
            <TableRowContent pseudoTable={props.pseudoTable}>
                <Text color={textColor} size={props.pseudoTable ? 'secondary' : 'main'} textAlign={props.pseudoTable ? 'right' : null}>
                    {props.children}
                </Text>
            </TableRowContent>
        </TableRowContainer>
    );
};

TableRow.propTypes = {
    title: PropTypes.string,
    textColor: PropTypes.oneOf(['primary', 'lightGray']),
    titleColor: PropTypes.oneOf(['secondary', 'primary', 'lightGray']),
    pseudoTable: PropTypes.bool,
    onClick: PropTypes.func,
};
